import { Filter } from "@/lib/filterable";
import { formatAsFullDateAndFullHour } from "@/lib/utility/date-helper";
import {
  MrfiktivPartialAddressWithGeoViewModelGen,
  MrfiktivTowingDetailsGen,
  MrfiktivTowingDetailsViewModelGen
} from "@/services/mrfiktiv/v1/data-contracts";
import { AddressWithGeo } from "./address.entity";

class TowingDetailsBase implements MrfiktivTowingDetailsViewModelGen {
  /**
   * @inheritdoc
   */
  companyId?: string;

  /**
   * @inheritdoc
   */
  documentId?: string;

  /**
   * @inheritdoc
   */
  externalId?: string;

  /**
   * @inheritdoc
   */
  url?: string;

  /**
   * @inheritdoc
   */
  notes?: string;

  /**
   * @inheritdoc
   */
  pickupDate?: string;

  get pickupDateFormable(): string {
    if (!this.pickupDate) {
      return "";
    }
    return formatAsFullDateAndFullHour(new Date(this.pickupDate).getTime());
  }
  set pickupDateFormable(date: string) {
    if (date) {
      this.pickupDate = new Date(date).toISOString();
    }

    this.pickupDate = date;
  }

  /**
   * @inheritdoc
   */
  pickupLocation: MrfiktivPartialAddressWithGeoViewModelGen;

  /**
   * @inheritdoc
   */
  deliveryDate?: string;

  get deliveryDateFormable(): string {
    if (!this.deliveryDate) {
      return "";
    }
    return formatAsFullDateAndFullHour(new Date(this.deliveryDate).getTime());
  }
  set deliveryDateFormable(date: string) {
    if (date) {
      this.deliveryDate = new Date(date).toISOString();
    }

    this.deliveryDate = date;
  }

  /**
   * @inheritdoc
   */
  deliveryLocation: MrfiktivPartialAddressWithGeoViewModelGen;

  /**
   * @inheritdoc
   */
  cost?: number | null;

  /**
   *
   * @param obj
   */
  constructor(obj?: Partial<MrfiktivTowingDetailsViewModelGen>) {
    this.companyId = obj?.companyId;
    this.documentId = obj?.documentId;
    this.externalId = obj?.externalId;
    this.url = obj?.url;
    this.notes = obj?.notes;
    this.pickupDate = obj?.pickupDate;
    this.pickupLocation = new AddressWithGeo(obj?.pickupLocation);
    this.deliveryDate = obj?.deliveryDate;
    this.deliveryLocation = new AddressWithGeo(obj?.deliveryLocation);
    this.cost = obj?.cost;
  }

  get dto(): MrfiktivTowingDetailsGen {
    return {
      companyId: this.companyId,
      documentId: this.documentId,
      externalId: this.externalId,
      url: this.url,
      notes: this.notes,
      pickupDate: this.pickupDate,
      pickupLocation: new AddressWithGeo(this.pickupLocation),
      deliveryDate: this.deliveryDate,
      deliveryLocation: new AddressWithGeo(this.deliveryLocation),
      cost: this.cost
    };
  }
}

type ITowingDetails = TowingDetailsBase;
const TowingDetails = Filter.createForClass(TowingDetailsBase);

export { ITowingDetails, TowingDetails };
